import { X, Search } from 'lucide-react';

export interface DateRangeFilter {
  field: string;
  label: string;
  from: string;
  to: string;
}

export interface SelectFilter {
  field: string;
  label: string;
  value: string;
  options: { value: string; label: string }[];
}

interface AdvancedSearchProps {
  dateFilters?: DateRangeFilter[];
  selectFilters?: SelectFilter[];
  onDateFilterChange?: (field: string, type: 'from' | 'to', value: string) => void;
  onSelectFilterChange?: (field: string, value: string) => void;
  onClear?: () => void;
  onSearch?: () => void;
}

export default function AdvancedSearch({
  dateFilters = [],
  selectFilters = [],
  onDateFilterChange,
  onSelectFilterChange,
  onClear,
  onSearch,
}: AdvancedSearchProps) {
  return (
    <div 
      className="mb-3 p-3 rounded-lg border animate-fadeIn"
      style={{ 
        backgroundColor: 'var(--background-card)',
        borderColor: 'var(--border-color)',
      }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {/* Date Range Filters */}
        {dateFilters.map((filter) => (
          <div key={filter.field}>
            <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>
              {filter.label}
            </label>
            <div className="flex items-center gap-1">
              <input
                type="date"
                value={filter.from}
                onChange={(e) => onDateFilterChange?.(filter.field, 'from', e.target.value)}
                className="input-field text-sm py-1"
              />
              <span className="text-xs" style={{ color: 'var(--text-tertiary)' }}>〜</span>
              <input
                type="date"
                value={filter.to}
                onChange={(e) => onDateFilterChange?.(filter.field, 'to', e.target.value)}
                className="input-field text-sm py-1"
              />
            </div>
          </div>
        ))}

        {/* Select Filters */}
        {selectFilters.map((filter) => (
          <div key={filter.field}>
            <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>
              {filter.label}
            </label>
            <select
              value={filter.value}
              onChange={(e) => onSelectFilterChange?.(filter.field, e.target.value)}
              className="input-field text-sm py-1 w-full"
            >
              <option value="">すべて</option>
              {filter.options.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-end gap-2 mt-3 pt-2 border-t" style={{ borderColor: 'var(--border-color)' }}>
        <button
          type="button"
          onClick={onClear}
          className="btn btn-outline btn-sm"
        >
          <X size={14} />
          クリア
        </button>
        <button
          type="button"
          onClick={onSearch}
          className="btn btn-primary btn-sm"
        >
          <Search size={14} />
          検索
        </button>
      </div>
    </div>
  );
}
